// extracted by mini-css-extract-plugin
export default {"app_wrapper":"App_app_wrapper__x0wLO"};